


































































import store from '@/store';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import {GlobalModal} from '@webstacz/vue-components';
import {Mixin} from "@/mixins";
import Section from "@/components/Section.vue";
import Sidebar from "@/components/Sidebar.vue";
import Modal from "@/components/Modal.vue";
import SidebarBottom from "@/components/SidebarBottom.vue";
import PersonalizedCartIntro from "@/components/PersonalizedCartIntro.vue";
import axios from './plugins/axios';
import CheckoutServerData, {Country, Option} from "@/types/CheckoutServerData";
import {captureEvent} from "@sentry/browser";

@Component({
    components: {
        PersonalizedCartIntro,
        SidebarBottom,
        Sidebar,
        Section,
        GlobalModal,
        Modal,
    },
})
export default class App extends Mixins(Mixin) {
    //<editor-fold desc="Private properties">
    store = store(this.$route.params.personalizedCartId || null);
    ecoMobilierModalOpen = false;

    personalizedCartData = typeof personalizedCartData !== 'undefined' ? personalizedCartData : null;
    //</editor-fold>

    //<editor-fold desc="Props">
    @Prop({required: true})
    checkoutData!: CheckoutServerData;

    @Prop({required: true})
    countries!: { [key: string]: Country } | null;

    @Prop({required: true})
    payments!: { [key: number]: Option } | null;
    //</editor-fold>

    //<editor-fold desc="Refs">
    //</editor-fold>

    //<editor-fold desc="Watchers">
    //</editor-fold>

    //<editor-fold desc="Getters">
    //</editor-fold>

    //<editor-fold desc="Hooks">
    created() {
        if (
            typeof this.checkoutData !== 'undefined'
            && this.checkoutData !== null
            && Object.keys(this.checkoutData).length > 0
        ) {
            try {
                this.store.setCartData(this.checkoutData);
                this.store.setShippingOptions(this.checkoutData.shippingOptions);
            } catch (e) {
                // ignore - probably invalid json format
                //this.store.cartData()
                // @TODO bypass this (?)
                captureEvent(e);
            }
        } else if (this.checkoutData === null) {
            this.store.loading = false;
        } else {
            //this.store.cartData();
            captureEvent(new Error('No checkout data provided'));
            this.store.loading = false;
            // @TODO bypass this (?)
        }

        if (
            typeof this.countries !== 'undefined'
            && this.countries !== null
            && Object.keys(this.countries).length > 0
        ) {
            this.store.setCountries(this.countries);
        }
    }

    mounted() {
        window.addEventListener('scroll', this.onScroll);
        this.onScroll();

        if (!this.store.serverData || !this.store.serverData.configurableProductsPriceNetto) {
            return;
        }

        const configurablePrice = this.store.serverData.configurableProductsPriceNetto;
        if (configurablePrice > 0) {
            let location: string | undefined = undefined;
            if (this.store.flatProducts.find((product) => !!product.from_pfc)) {
                location = 'pfc';
            }

            if (window.pushDataLayer) {
                window.pushDataLayer('lead_view_cart', this.store.flatProducts[0].type, configurablePrice, location);
            }
        }
    }

    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll);
    }

    //</editor-fold>

    //<editor-fold desc="Methods">
    onScroll() {
        const footer = <HTMLDivElement>this.$refs.footer;
        const form = <HTMLElement>this.$refs.form;
        if (footer) {
            if (0 > form.getBoundingClientRect().bottom - window.innerHeight) {
                footer.classList.add('not-fixed');
            } else {
                footer.classList.remove('not-fixed');
            }
        }
    }

    async closePersonalizedCartModal() {
        personalizedCartData.showModal = false;
        this.$nextTick(() => {
            this.store.loading = true;
            this.store.personalizedCartId = null;
            if (!!this.store.serverData.originRoute) {
                window.location.replace(this.store.serverData.originRoute);
            } else {
                const {href} = this.$router.resolve({name: 'cart'});
                window.location.replace(href);
            }
        });
    }

    async mergeCart(merge: boolean) {
        personalizedCartData.showModal = false;
        this.store.loading = true;
        try {
            const {data} = await axios.post(`/api/cart/merge/${this.store.personalizedCartId!}`, {
                merge: merge,
            });

            const {location} = data;
            if (location) {
                window.location.replace(location);
            } else {
                throw new Error('No location provided');
            }
        } catch (e) {
            captureEvent(e);
            window.location.replace(location.href);
        }
    }

    //</editor-fold>
}
